export default class QuotePricingInput {
    constructor(item) {
        this.quoteId = item.quoteId;
        this.useLatestDiscounts = item.useLatestDiscounts;
        this.dealerBranchId = item.dealerBranchId;
        this.priceZoneId = item.priceZoneId;
        this.carrierId = item.carrierId;
        this.attachmentPoints = item.attachmentPoints;
        this.products = item.products;
        this.customLineItems = item.customLineItems;
        this.optInDiscounts = item.optInDiscounts;
    }
}
